// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import 'swiper/dist/css/swiper.min.css'
import 'font-awesome/css/font-awesome.css'
import 'font-awesome/css/font-awesome.min.css'
import './assets/css/app.css'

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})


// WEBPACK FOOTER //
// ./src/main.js